declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_right_in_left_foo extends $mol_object {
		a( ): any
	}
	
	export class $mol_view_tree2_to_js_test_ex_right_in_left_bar extends $mol_object {
		b( ): ReturnType< ReturnType< $mol_view_tree2_to_js_test_ex_right_in_left_bar['Cls'] >['a'] >
		Cls( ): $mol_view_tree2_to_js_test_ex_right_in_left_foo
		Menu_title( ): ReturnType< ReturnType< $mol_view_tree2_to_js_test_ex_right_in_left_bar['Menu'] >['Title'] >
		Menu( ): $mol_page
		foo( ): ReturnType< $mol_view_tree2_to_js_test_ex_right_in_left_bar['Cls'] >
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=right_in_left_bind.view.tree.d.ts.map